import DisplayData from "./DisplayData";

//App
import { AddressDataProps } from "../../../types";

const AddressData = (props: AddressDataProps) => {
    const { text, AddressLine1, AddressLine2, City, State, ZipCode, County, hideColon = false, isBold = true } = props;
    return (
        <>
            {AddressLine1 && City && State && ZipCode && (
                <DisplayData
                    text={text}
                    isBold={isBold}
                    hideColon={hideColon}
                    importedData={
                        <>
                            {AddressLine1}<br />
                            {AddressLine2 && (<> {AddressLine2}<br /> </>)}
                            {City}{","} {State} {ZipCode}<br />
                            {County && (<> {County} </>)}
                        </>
                    }
                />
            )}
        </>
    );
};

export default AddressData;
